import React from 'react';
import {
	Container,
	Box,
	Grid,
	Paper,
	Divider,
	TableContainer,
	Table,
	TableHead,
	TableBody,
	TableRow,
	Avatar,
	withStyles,
	TableCell,
} from '@material-ui/core';
import BodyText from './BodyText';
import DashboardTable from './DashboardTable';
import { useSelector } from 'react-redux';
import TitleText from './TitleText';
import FlightModalDetail from './FlightModalDetail';
const tableHeaders = [
	'ORDER_ID',
	'Depart From',
	'Journey To',
	'Date of Booking',
	'Journey Date',
	'Ticket Cost',
	'Status',
	'Action',
];

const StyledTableCell = withStyles((theme) => ({
	head: {
		fontWeight: 600,

		// padding: 3,
		fontSize: 14,
		textTransform: 'uppercase',
		background: 'aliceblue',
	},
	root: {
		borderBottom: 'none',
		paddingBottom: 0,
	},
}))(TableCell);
const BookingHistory = () => {
	const { bookinghistory, bookinghistoryagent } = useSelector(
		(state) => state.user
	);
	return (
		<>
			<Grid container spacing={2}>
				<Box>
					<h2 style={{ fontFamily: 'Josefin Sans, sans-serif' }}>
						Booking History
					</h2>
				</Box>
				<Grid item xs={12}>
					<TableContainer style={{ marginTop: 15 }}>
						<Table>
							<TableHead>
								<TableRow>
									{tableHeaders.map((title, index) => (
										<StyledTableCell key={title}>{title}</StyledTableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody style={{ marginTop: 20 }}>
								{bookinghistory
									? bookinghistory &&
									  bookinghistory.result &&
									  bookinghistory.result.flights.length > 0 &&
									  bookinghistory.result.flights.map((item, index) => {
											return <DashboardTable item={item} rowIndex={index} />;
									  })
									: bookinghistoryagent
									? bookinghistoryagent &&
									  bookinghistoryagent.result &&
									  bookinghistoryagent.result.flights.length > 0 &&
									  bookinghistoryagent.result.flights.map((item, index) => {
											return <DashboardTable item={item} rowIndex={index} />;
									  })
									: ''}
							</TableBody>
						</Table>
					</TableContainer>
				</Grid>
			</Grid>
			<FlightModalDetail />
		</>
	);
};

export default BookingHistory;
